module.exports = __webpack_public_path__ + "components/weather-icon/static/nightmodrain@2-faefe6aeb35521aa1d51e71fc3dfccc8.png";